import { isValidAbsoluteUrl } from '@libs/shared';

/**
 * 获取规范化的 HTTP(S) 绝对地址，相对地址基于当前页面 origin 解析
 * @param url HTTP(S) 绝对地址、相对地址或协议相对地址
 * @returns 有效的绝对地址，非法输入返回 undefined
 */
export const getValidAbsoluteUrl = (url: string): string | undefined => {
    try {
        // 空白地址也能被 URL 解析为站点根地址，需提前拒绝
        if (!url.trim()) {
            return undefined;
        }
        const absoluteUrl = new URL(url, window.location.origin).href;
        // 解析后已补齐协议，复用绝对地址校验以限定为 HTTP(S) 地址
        if (!isValidAbsoluteUrl(absoluteUrl)) {
            return undefined;
        }
        return absoluteUrl;
    } catch {
        return undefined;
    }
};
